import _ from 'lodash';
import MessageBusTopics from '../../../../common/MessageBusTopics';
import SearchUiDom from './SearchUiDom';
import SearchUiDomEventHandler from './SearchUiDomEventHandler';
import SearchUiDomUpdater from './SearchUiDomUpdater';

/**
 * Search UI Controller constructor
 *
 * @param {object} messageBus  WH message bus
 *
 * @constructor
 */
function SearchUiController(deps) {

    this.deps = deps || {};

    this.dom = new SearchUiDom();

    this.subscribeToScrollEvents();
    this.subscribeToAddToSlipRelatedEvents();

    this.searchUiDomEventHander = new SearchUiDomEventHandler(this.dom);
    this.searchUiDomUpdater = new SearchUiDomUpdater(this.dom, deps);
}

/**
 * Subscribing for the events that manipulates the behaviour of scrolling
 *
 * @returns {void}
 *
 * @private
 */
SearchUiController.prototype.subscribeToScrollEvents = function () {

    /**
     * Indicates whether the previously triggered requests are responded or not.
     *
     * @type {boolean}
     */
    this.shouldTriggerLoadMore = true;

    /**
     * Indicates whether there are more results to load or not.
     *
     * @type {boolean}
     */
    this.hasMoreResults = false;

    window.WH.messageBus.subscribe(MessageBusTopics.SEARCH_EVENTS_SCROLL, this.onEventsScrolled.bind(this));
    window.WH.messageBus.subscribe(MessageBusTopics.SEARCH_REQUEST_SUCCESS, this.onRequestSuccess.bind(this));
    window.WH.messageBus.subscribe(MessageBusTopics.SEARCH_REQUEST_FAILED, this.onRequestFailed.bind(this));
    window.WH.messageBus.subscribe(MessageBusTopics.SEARCH_STATE_RESET, this.resetLoadMoreTrigger.bind(this));
};

/**
 * Handler function for scrolling the events results
 *
 * @param {String} eventName
 * @param {Object} domEvent
 *
 * @returns {void}
 *
 * @private
 */
SearchUiController.prototype.onEventsScrolled = function (eventName, domEvent) {

    var scrollThreshold = 15;

    if (this.shouldTriggerLoadMore === true && this.hasMoreResults === true) {

        var eventsContainer = domEvent.currentTarget;
        var actualScrollPosition = eventsContainer.clientHeight + eventsContainer.scrollTop;
        var hasReachedTheBottom = eventsContainer.scrollHeight - scrollThreshold <= actualScrollPosition;

        if (hasReachedTheBottom === true) {

            this.shouldTriggerLoadMore = false;

            window.WH.messageBus.publish(MessageBusTopics.SEARCH_EVENTS_LOAD_MORE, {});
        }
    }
};

/**
 * Handler function for successful request
 *
 * @returns {void}
 */
SearchUiController.prototype.onRequestSuccess = function () {
    this.resetLoadMoreTrigger();
};

/**
 * Handler function for failed request
 *
 * @returns {void}
 */
SearchUiController.prototype.onRequestFailed = function () {
    this.resetLoadMoreTrigger();
};

/**
 * Resets the Load More Trigger to let scrolling trigger the load more event once reached the bottom
 *
 * @returns {void}
 *
 * @private
 */
SearchUiController.prototype.resetLoadMoreTrigger = function () {

    this.shouldTriggerLoadMore = true;
};

/**
 * Subscribing for the events that interacts with the market selection buttons
 *
 * @returns {void}
 *
 * @private
 */
SearchUiController.prototype.subscribeToAddToSlipRelatedEvents = function () {
    window.WH.messageBus.subscribe(
        MessageBusTopics.SEARCH_EVENT_ITEMS_UPDATED, this.triggerSelectionsLoaded.bind(this)
    );
};

/**
 * Highlight betslip selections and binds betslip action to the button
 *
 * @returns {void}
 *
 * @private
 */
SearchUiController.prototype.triggerSelectionsLoaded = function () {
    this.deps.SelectionViewAdapter.highlightAddedSelections();
    window.WH.messageBus.publish(
        MessageBusTopics.SELECTION_VIEW_ADAPTER_SELECTIONS_LOADED, this.dom.eventsResults.selector
    );
};

/**
 * Triggering DOM update
 *
 * @param {Object} searchResultsItems  Search Result items
 * @param {Object} config  configuration object
 *
 * @returns {void}
 *
 * @public
 */
SearchUiController.prototype.update = function (searchResultsItems, config) {

    this.hasMoreResults = config.hasMoreResults;

    if (!_.isEmpty(searchResultsItems)) {

        window.WH.messageBus.publish(MessageBusTopics.SEARCH_EVENT_ITEMS_UPDATE, {
            reset: config.reset,
            hasMoreResults: config.hasMoreResults,
            results: searchResultsItems.events,
        });

        window.WH.messageBus.publish(MessageBusTopics.SEARCH_ICON_BAR_UPDATE, {
            reset: config.reset,
            sportsResults: searchResultsItems.sports,
            customResults: searchResultsItems.custom,
        });

        window.WH.messageBus.publish(MessageBusTopics.SEARCH_LABELS_UPDATE, {
            sportsTotal: searchResultsItems.sports.total,
            eventsTotal: searchResultsItems.events.total,
            customTotal: searchResultsItems.custom.total,
        });
    }
};

export default SearchUiController;
